module.exports = __webpack_public_path__ + "static/media/payment4.93a9fb25.svg";